import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Grid2Component } from './grid2.component';
import { GridRestComponent } from './grid-rest.component';

import { GenericService } from '../../services/generic/generic.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        Grid2Component,
        GridRestComponent
    ],
    declarations: [
        Grid2Component,
        GridRestComponent
    ],
    providers: [
        GenericService
    ]
})

export class Grid2Module { }